import React from "react";
import { BuilderAsset } from "../../entities/BuilderAsset";
import { OfflineBuilderAsset } from "../../entities/OfflineBuilderAsset";
import { OfflineActionLocation } from "../../utilities/Tracking/EventTracking";

export interface OfflineAssets {
    onlineMode: boolean
    offlineBuilderAssets: OfflineBuilderAsset[];
    toggleOfflineMode: (offlineMode: boolean) => void;
    setAssetOfflineMode: (builderAssetId: string, offlineMode: boolean, actionLocation?: OfflineActionLocation) => Promise<BuilderAsset | null>;
    saveBuilderAssetOffline: (builderAsset: BuilderAsset) => BuilderAsset;
}

export const OfflineAssetsContext = React.createContext<OfflineAssets>({} as any);

export function useOfflineAssets() {
	return React.useContext(OfflineAssetsContext);
}